// Persistent cart utility (localStorage)
class CartManager {
  constructor() {
    this.storageKey = 'gored_cart';
  }

  getCart() {
    const cart = localStorage.getItem(this.storageKey);
    return cart ? JSON.parse(cart) : [];
  }

  addItem(item) {
    const cart = this.getCart();
    const existingItemIndex = cart.findIndex(
      cartItem => cartItem.size === item.size
    );

    if (existingItemIndex > -1) {
      cart[existingItemIndex].quantity += item.quantity;
    } else {
      cart.push(item);
    }

    localStorage.setItem(this.storageKey, JSON.stringify(cart));
    return cart;
  }

  removeItem(size) {
    let cart = this.getCart();
    cart = cart.filter(item => item.size !== size);
    localStorage.setItem(this.storageKey, JSON.stringify(cart));
    return cart;
  }

  updateQuantity(size, quantity) {
    const cart = this.getCart();
    const itemIndex = cart.findIndex(item => item.size === size);
    
    if (itemIndex > -1) {
      if (quantity <= 0) {
        return this.removeItem(size);
      }
      cart[itemIndex].quantity = quantity;
      localStorage.setItem(this.storageKey, JSON.stringify(cart));
    }
    return cart;
  }

  clearCart() {
    localStorage.removeItem(this.storageKey);
    return [];
  }

  getCartTotal() {
    const cart = this.getCart();
    return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  }

  getCartCount() {
    const cart = this.getCart();
    return cart.reduce((count, item) => count + item.quantity, 0);
  }
}

export const cartManager = new CartManager();
